<template>
  <v-container fluid>
    <!-- <v-row justify="center mt-15"> -->
       <!-- <div class="mt-15">
        <button @click="showLeaveForm = true">Open Leave Form</button>
        <NewLeave v-if="showLeaveForm" @cancel="showLeaveForm = false" />
      </div> -->
      
    <v-row class="mt-2" justify="center">
      <v-btn @click="get_employees()"> get employees</v-btn>     
    <v-dialog
      v-model="new_leave_dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
    
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          @click="initFormData()"
        >
          New Request
        </v-btn>
           
      </template>
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="new_leave_dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Leave Request</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="setleaveFormData(),new_leave_dialog = false"
            >
              Save
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-form ref="leaveForm"  @submit.prevent >
        <v-container fluid>
    <v-row >
      <v-col cols="12" sm="6">
        <v-text-field label="Employee Code" v-model="employ_id" :rules="EmployeeCodeRules" disabled />
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field label="Employee Name" v-model="employee_name" :rules="EmployeeNameRules" disabled />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6">
        <v-select
          :items="leavetypes" 
          item-text = "PLV_DESC"
          label="Leave Type"
          :rules="leaveTypeRules"
          v-model="selectedLeaveType"
        >
        <template #selection="{ item }">
            {{ item.PLV_DESC }}
          </template>
          <template #item="{ item }">
            <v-list-item-content>
              <v-list-item-title v-if="displayedLeaveTypes.includes(item.PLV_DESC)">
                {{ item.PLV_DESC }}
              </v-list-item-title>
              <v-list-item-title v-else :class="{ 'grey--text': true }">
                {{ item.PLV_DESC }}
              </v-list-item-title>
            </v-list-item-content>
          </template>
        </v-select>
      </v-col>
    <!-- </v-row>
     <v-row> -->
      <v-col cols="12"  sm="6">
        <v-text-field
          label="Reason"
          :rules="remarksRules"
          :counter="50"
          v-model="remarks"           
        />
      </v-col>
    </v-row>
    <v-col cols="12" sm="6"  md="4">
    <v-dialog
      ref="from_date_dialog"
      v-model="fromdateModal"      
      :return-value.sync="date"
      persistent
      width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="fromDate"
          label="From Date"
          prepend-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
          :rules="fromDateRules"
          @input="numberOfLeaveDays"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="fromDate"        
        scrollable
      >
        <v-spacer></v-spacer>
        <v-btn
          text
          color="primary"
          @click="fromdateModal = false"
        >
          Cancel
        </v-btn>
        <v-btn
          text
          color="primary"
          @click="$refs.from_date_dialog.save(fromDate)"
        >
          OK
        </v-btn>
      </v-date-picker>
    </v-dialog>
  </v-col>
   <v-col cols="12" sm="6" md="4" >
    <v-dialog
      ref="to_date_dialog"
      v-model="todateModal"
      :return-value.sync="date"
      persistent
      width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="toDate"
          label="To Date"
          prepend-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
          :rules="toDateRules"
          @input="numberOfLeaveDays"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="toDate"
        scrollable
      >
        <v-spacer></v-spacer>
        <v-btn
          text
          color="primary"
          @click="todateModal = false"
        >
          Cancel
        </v-btn>
        <v-btn
          text
          color="primary"
          @click="$refs.to_date_dialog.save(toDate)"
        >
          OK
        </v-btn>
      </v-date-picker>
    </v-dialog>
  </v-col>
    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field
          label="Number of Leave Days"
          v-model="numberOfLeaveDays" 
          :rules="remainingdaysRules"
                   
        />
      </v-col>     
      <v-col cols="12" sm="6">
        <!-- <v-text-field disabled
          label="Remaining Leave Days"
          v-model="remainingLeaveDays"
          disabled
        /> -->
        <v-checkbox v-if="isHalfDay" v-model="isHalfDaySelected" label="Half Day"></v-checkbox>
      </v-col>
    </v-row>   
    <v-row>      
      <v-col cols="12"  class="text-center">
        <v-btn 
        color="primary"
        dark        
        type="submit"
        @click="submitLeaveRequest"       
        >
        {{ isSubmitting ? 'Submitting...' : 'Submit leave request' }}       
        </v-btn>
      </v-col>
      
      </v-row>
      <v-row>      
        <v-col cols="12" sm="6">
          <v-text-field label="Created By" v-model="user.USER_NAME" :rules="EmployeeNameRules" disabled />
        </v-col>
      </v-row>
      </v-container>
    </v-form>
     </v-card>
    </v-dialog>
  </v-row>
  <v-row>
    <v-col cols="8">
        <!-- <v-select
          :items="employees"         
          item-value="EMPMST_DOCNO"
          item-text="EMPMST_NAME"
          label="Employee name"
          solo
          v-model="selectedEmployee"
          @change="get_AllLeaves()"
          clearable
        /> -->
        <v-autocomplete
          clearable
          label="Employee name"
          :items="employees"
          variant="outlined"
          item-value="EMPMST_DOCNO"
          item-text="EMPMST_NAME"
          v-model="selectedEmployee"
          @change="get_AllLeaves()"
        ></v-autocomplete>
      </v-col>
      <v-col cols="2" >
        <v-btn color="primary" dark @click="get_AllLeaves()">         
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="2" >
        <v-btn color="primary" dark @click="get_AllLeaves(true)">         
          <!-- <v-icon left>mdi-refresh</v-icon> -->
          <span>Reset</span>
        </v-btn>
      </v-col>    

  </v-row>
   <v-card class="mx-2">    
    <v-row>
      <v-col :cols="12" >
        <v-card-title class="leave-summary-title">Leave Summary : ({{this.employ_id}}) <span>{{ employee_name }} </span></v-card-title> 
      </v-col>      
    </v-row>
    <v-row>
      <v-col :cols="12" md="4" v-for="leaveType in displayedLeaveTypes" :key="leaveType">
        <v-card
          class=" pa-2 mb-2 "
          color="#26c6da"
          dark
          width="100%"
        >
         <div class="d-inline-flex pa-2 text-center">            
            {{ leaveType }} taken: {{leaveSummary[leaveType]}} / {{ availableMaxLeave(leaveType) }}
          </div>          
        </v-card>
      </v-col>
    </v-row>
  </v-card>
 
  <v-layout row wrap class="mt-5">
      <v-flex xs12   v-for="leave in allleaves" :key="leave.ABS_DOCNO" cols="12" sm="4">     
        <LeaveFlip  :leave=leave />     
      </v-flex>
    </v-layout>
     <v-row>
     </v-row>
  </v-container> 
</template>

<script>
// import Leave from '../components/Leave.vue'
import LeaveFlip from '../components/LeaveFlip.vue'
// import NewLeave from '../components/NewLeave.vue'
import moment from 'moment';
import secure_axios from "../services/secure_axios";

export default {
  components: {
    // NewLeave,
    LeaveFlip,
  },
  data() {
    return {
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      minDate: new Date(new Date().setDate(new Date().getDate() - 2)),
      leaveTypes: [],
      selectedLeaveType: null ,
      selectedEmployee:"",
      fromDate: null,
      toDate: null,
      remarks: '', 
      fromdateModal: false,
      todateModal:false,
      selectedleave: null,
      showPopup: false,
      from_date_dialog:false,
      to_date_dialog:false,
      isHalfDaySelected: false,
      new_leave_dialog:false,
      showLeaveForm: false,
      isSubmitting: false,
      
    };
  }, 
  watch:{
    selectedLeaveType(){       
      this.$forceUpdate(this.remainingdaysRules);
    }
  } ,
  computed: {
    sessionAPI() {
      return this.$store.getters.sessionAPI
    },
    numberOfLeaveDays: {
      get() {
      if (this.fromDate && this.toDate) {
        const start = moment(this.fromDate);
        const end = moment(this.toDate);
        const days = end.diff(start, 'days') + 1;
        return this.isHalfDaySelected && this.isHalfDay ? days -0.5 : days;
      }
      return 0; },  
      set() {
      }   
    },
    user(){     
      return this.$store.getters.factsuser;      
    },
    
    userProfile(){
      return this.$store.getters.userProfile;
    },
    leaveFormData(){
      return this.$store.getters.leaveFormdata;
    },
    allleaves(){
      return this.$store.getters.allleaves;
    },
    leavetypes(){
      return this.$store.getters.leavetypes;
    }, 
    employ_id(){
      if (this.selectedEmployee) {
        return this.selectedEmployee;
      } else {
        return this.user.USER_EMP_DOCNO;
      }
    },  
    employee_name()  {
      if (this.selectedEmployee) {      
        return `${this.employees.find(type => type.EMPMST_DOCNO === this.selectedEmployee)?.EMPMST_NAME}`
      } else {
        return `${this.userProfile.EMPMST_NAME }`
      }
    },
    leaveSummary() {
      const allLeaves = this.allleaves;
      const leaveTypes = this.leavetypes;

      const summary = {};

      leaveTypes.forEach(type => {
        const typeId = type.PLV_DOCNO;
        const typeName = type.PLV_DESC;

        summary[typeName] = 0;

        allLeaves.forEach(leave => {
          if (leave.ABS_ABSENT_TYPE_DOCNO === typeId) {
            summary[typeName] += leave.ABS_ABSENT_DAYS;
          }
        });
      });

      return summary;
    },
    availableCasualLeave(){      
      return 7.0 - parseFloat(this.leaveSummary["Casual leave"])
    },
    availableSickLeave(){
      return 7.0 - parseFloat(this.availableCasualLeave[ "Sick Leave"])
    },    
    isHalfDay() {
      return this.fromDate && this.toDate && this.fromDate === this.toDate;
    },
    displayedLeaveTypes() {
      return ["Casual leave", "Sick Leave", "Absent (Loss of pay B)","Compensatory Leave"];
    },
    availableCompensatoryLeaves(){
      return this.$store.getters.compensatoryLeaves;
    },
    EmployeeCodeRules (){
    return [
        v => !!v || 'EmployeeCode type is required',
      ]
    },
    EmployeeNameRules (){
    return [
        v => !!v || 'EmployeeName type is required',
      ]
    },
    leaveTypeRules (){
    return [
        v => !!v || 'Leave type is required',
        v => this.displayedLeaveTypes.includes(v) || 'Only allowed to select enabled leave types',
        // v => v==="Casual leave"? this.availableCasualLeave >= this.numberOfLeaveDays|| `This leave type over the limit ${this.v}` : true,
        // v => v==="Sick Leave"? this.availableSickLeave >= this.numberOfLeaveDays|| `This leave type over the limit ${this.v}` : true,
        // v => {
        //   if(v=='Casual leave' && this.numberOfLeaveDays <= this.availableCasualLeave ){
        //     return `You only have ${this.availableCasualLeave} days of Casual leave left`;}
        //   else if (v == 'Sick Leave' &&  this.availableSickLeave >= this.leaveDays ) {
        //     return `You only have ${this.availableSickLeave} days of Sick Leave left`;} 
        //   else {
        //     return true;}
        // }
      ]
    },
    fromDateRules () {
      return [
        v => !!v || 'From date is required',
        v => new Date(v) >= this.minDate || 'Allowed only to request from last day on app' ,
        v => this.toDate ? v <= this.toDate || 'From date must be on or before to date' : true,        
      ]
    },
    toDateRules () {
      return [
        v => !!v || 'To date is required',
        v => this.fromDate ? v >= this.fromDate || 'To date must be on or after from date' : true,
      ]
    },
    remarksRules () {
      return [
        v => !!v || 'Remarks is required',
        v => (v && v.length >= 15 && v.length <= 50) || 'Remarks must be between 15 and 50 characters',
        // v => !/(.)\1/.test(v) || 'Remarks cannot have repeated characters',
        v => !/[^a-zA-Z0-9\s]/.test(v) || 'Remarks cannot contain special characters'
      ]
    },
    remainingdaysRules(){
      return[
        v=> !!v || 'required',
        v => v >= 0 || 'Leave days cannot be negative',
        v=> v <= this.remainingLeaveDays() ||`${this.selectedLeaveType } max ${this.remainingLeaveDays() } days`,
        v=> v == this.numberOfLeaveDays ||  'Leave days should match the count from and to date',
      ]
    },
    employees(){
      return this.$store.getters.employees
    },
  },
  methods: {
    get_AllLeaves(isReset=false){
      this.$store.dispatch("getAllLeaves", { employ_id:this.employ_id, isReset  })
    },
    async get_CompensatoryLeaves(){     
      await this.$store.dispatch("getCompensatoryLeaves", { employ_id:this.employ_id  })
    },
    async get_employees(){
      await this.$store.dispatch("get_employee", { employ_id: this.user.USER_EMP_DOCNO})
      await this.$store.dispatch("get_employees", { employ_id: this.user.USER_EMP_DOCNO ,EMPMST_DESG_DOCNO:this.userProfile.EMPMST_DESG_DOCNO,dep:this.userProfile.EMPMST_UD_TXT5,USER_LOGINID:this.user.USER_LOGINID})
    },
    fetchLeaveTypes(){
       this.$store.dispatch("getAllLeaves")
    },
    initFormData(){
      if(this.leaveFormData !== null && this.leaveFormData !== undefined){
        // console.log(this.leaveFormData)
      let leave_data = this.leaveFormData
      // console.log(leave_data.ABS_NARRATION)
      this.selectedLeaveType = leave_data.ABS_NARRATION
      this.fromDate = leave_data.ABS_FROMDATE
      this.toDate = leave_data.ABS_TODATE
      this.remarks = leave_data.remarks
      // console.log(this.remarks)
    }
    },
    setleaveFormData(){
      const leave_data = {
        ABS_EMP_DOCTYPE:this.userProfile.EMPMST_DOCTYPE,
        ABS_EMP_DOCNO:this.employ_id,
        ABS_FROMDATE:this.fromDate,
        ABS_TODATE:this.toDate,
        ABS_NARRATION:this.remarks,
        ABS_CREATED_BY:this.user.USER_LOGINID,
        ABS_ABSENT_TYPE_DOCNO:this.getLeaveTypeNo(this.selectedLeaveType),
        ABS_ABSENT_DAYS:this.numberOfLeaveDays,
        ABS_PAYMENT_FACTOR:this.getLeavePaymentfactor(this.selectedLeaveType),
        // selectedLeaveType : this.selectedLeaveType
      };
      // console.log(this.userProfile.EMPMST_DOCTYPE)
        this.$store.dispatch("setleaveFormdata", leave_data)
      return leave_data;
    },
    checkAllRules() {
      const leaveTypeValid = this.leaveTypeRules.every(rule => rule(this.selectedLeaveType)===true);
      const fromDateValid = this.fromDateRules.every(rule => rule(this.fromDate) === true);
      const toDateValid = this.toDateRules.every(rule => rule(this.toDate)=== true);
      const remarksValid = this.remarksRules.every(rule => rule(this.remarks) === true);
      if(leaveTypeValid && fromDateValid && toDateValid && remarksValid){
        this.setleaveFormData();
        return true ;
      }else {
        return false;
      }
    },
    postleaveRequest(){      
      const asyncpostLeave= async () => {
          this.$store.dispatch("getLoading", true);    
          try {
            const resp = await secure_axios.post(this.sessionAPI + "leaves", {
             leave_data:this.leaveFormData,             
            });
            const data = resp.data
            const status = resp.status
            console.log(data)
            console.log(status)
            if(status==201){              
              this.new_leave_dialog= false;
              this.$store.dispatch("clearleaveFormdata")
              this.get_AllLeaves();
              this.isSubmitting = false;
            }          
          } catch (err) {
          // Handle Error Here
          console.error(err);
          this.$store.dispatch("getError", err);
        }
        
        this.$store.dispatch("getLoading", false);
        this.msgdialog = true;
        }
        asyncpostLeave();
    },
    // async submitLeaveRequest1(){  
    //   this.$refs.leaveForm.validate(valid => {
    //    if (valid) {
    //      // form is valid, submit the data
    //     console.log('Form is valid')
    //    } else {
    //      // form is not valid, show error message
    //      console.log('Form is not valid')
    //    }
    //  })
    //   this.setleaveFormData(); 
    //   if (this.checkAllRules()) { 
    //     this.isSubmitting = true
    //     this.postleaveRequest();         
    //   }       
    //},
    submitLeaveRequest() {
    if (this.$refs.leaveForm.validate()) {
      // Your submission logic here
      this.setleaveFormData(); 
       if (this.checkAllRules()) { 
         this.isSubmitting = true
         this.postleaveRequest();         
       }   
    } else {
      // Handle validation errors
    }
   },
    getLeaveTypeName(leaveTypeNo) {
      let leaveType = this.leavetypes.find(type => type.PLV_DOCNO === leaveTypeNo);
      return leaveType ? leaveType.PLV_DESC : '';
    },
    getLeaveTypeNo(leaveTypeName) {
      let leaveType= this.leavetypes.find(type => type.PLV_DESC === leaveTypeName);
      return leaveType ? leaveType.PLV_DOCNO : '';
    },
    getLeavePaymentfactor (leaveTypeName) {
    let leaveType= this.leavetypes.find(type => type.PLV_DESC === leaveTypeName);
    return leaveType ? leaveType.PLV_PAYMENT_FACTOR : '';
    },    
    formatDate(date){
      return moment(date).format('DD-MM-YYYY').toString()
    },
    statusInfo(leave){
      if(leave.ABS_POSTED_TS && leave.ABS_POSTED_BY){
        return `Posted By : ${leave.ABS_POSTED_BY} on:${ this.formatDate(leave.ABS_POSTED_TS)} `
      }else{
        return"Processing"
      }
    },
    // cardClass() {
    //   return `flip-card ${this.leave.status === 'processing' ? 'processing-card' : 'approved-card'}`;
    // },
    statuscolor(leave){
      return ` ${this.statusInfo(leave) === 'processing' ? 'yellow' : 'green'}`
    },
    availableMaxLeave(leaveType){
      // console.log('avl',leaveType)
      if (leaveType === "Compensatory Leave"){        
        if (this.availableCompensatoryLeaves !== undefined  && this.availableCompensatoryLeaves  !== null)        
          return parseInt(this.availableCompensatoryLeaves.reduce((sum, obj) => sum + obj.COM_ABSENT_DAYS, 0));
        else return 0
      }else{
      return parseInt(this.leavetypes.find(type => type.PLV_DESC === leaveType)?.PLV_ELIGIBLE_DAYS)
      }
    },

    remainingLeaveDays() {
      if (this.selectedLeaveType !='Absent (Loss of pay)'){
        let MaxLeave = this.availableMaxLeave(`${this.selectedLeaveType}`)
        let UsedLeave = this.leaveSummary[`${this.selectedLeaveType}`]
        let totalLeaveDays = MaxLeave- parseFloat(UsedLeave)
        return(totalLeaveDays)        
      }else{
        return 10
      }
    }, 

  },    
  created () {
    this.get_AllLeaves();
    this.get_CompensatoryLeaves();
    this.initFormData();
    // this.$store.dispatch("getAllLeaves");
    this.$store.dispatch("getLeaveTypes");
    if(!(this.userProfile == null || this.userProfile == undefined)){
      this.$store.dispatch("get_employee", { employ_id: this.user.USER_EMP_DOCNO })
      // this.get_employees();
    }
  },
  mounted() {    
    this.initFormData();
  },
}
</script>
<style scoped>
.summary-card {
  margin: 2px;
  text-align: center;
}

.leave-summary {
  display: inline-block;
  margin-right: 10px;
  text-align: center;
}

.leave-type {
  font-weight: bold;
}

.leave-count {
  margin-top: 5px;
}
.processing-card {
  background-color: #fff59d;
}

.approved-card {
  background-color: #c8e6c9;
}


.leave-summary-title{
  display: flex;
  justify-content: space-between;
}

.leave-summary-title span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 600px) {
  .leave-summary-title{
    flex-direction: column;
    align-items: flex-start;
  }
  
  .leave-summary-title span {
    white-space: normal;
    text-overflow: clip;
  }
}
</style>